import api from '@api';
import { call, put, select, takeEvery, all } from 'redux-saga/effects';
import { OverviewIntervalsResType } from 'src/types/overviewIntervals';
import { TimeRangesType } from 'src/containers/OverviewContainer/ChartContainer';
import {
    getOverviewIntervalDataFetchFailure,
    getOverviewIntervalDataFetchSuccess,
    getOverviewIntervalTypeDataFetchFailure,
    getOverviewIntervalTypeDataFetchSuccess,
    getOverviewIntervalOrdersInStatusesFetchFailure,
    getOverviewIntervalOrdersInStatusesFetchSuccess,
    getOverviewIntervalOrdersDeliveredFetchFailure,
    getOverviewIntervalOrdersDeliveredFetchSuccess,
} from './reducer';

export interface intervalParams {
    from: moment.Moment;
    to: moment.Moment;
    groupBy?: string;
}

const getOverviewIntervalOrdersFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/orders', { interval: data });
    return res.data.data;
};

const getOverviewIntervalActualOrdersFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/orders', { interval: data });
    return res.data.data;
};
const getOverviewIntervalPreviousOrdersFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/orders', { interval: data });
    return res.data.data;
};

const getOverviewIntervalReceivingsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/receivings', { interval: data });
    return res.data.data;
};

const getOverviewIntervalActualReceivingsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/receivings', { interval: data });
    return res.data.data;
};
const getOverviewIntervalPreviousReceivingsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/receivings', { interval: data });
    return res.data.data;
};

const getOverviewIntervalReturnsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/returns', { interval: data });
    return res.data.data;
};

const getOverviewIntervalActualReturnsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/returns', { interval: data });
    return res.data.data;
};
const getOverviewIntervalPreviousReturnsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/returns', { interval: data });
    return res.data.data;
};

const getOverviewIntervalClaimsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/claims', { interval: data });
    return res.data.data;
};

const getOverviewIntervalPreviousClaimsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/claims', { interval: data });
    return res.data.data;
};

const getOverviewIntervalActualClaimsFetchRequest = async (data: intervalParams) => {
    const res = await api('post', 'api/secure/statistics/new/interval-counts/claims', { interval: data });
    return res.data.data;
};

function* getOverviewIntervalDataFetch(action: { type: string; payload: TimeRangesType }) {
    const { start, end, prevStart, prevEnd, groupBy } = action.payload;
    try {
        yield all([
            call(function* () {
                const ordersDataActual: OverviewIntervalsResType = yield call((): any => getOverviewIntervalActualOrdersFetchRequest({ from: start, to: end }));
                yield put(getOverviewIntervalDataFetchSuccess({ ordersDataActual }));
            }),
            call(function* () {
                const ordersDataPrevious: OverviewIntervalsResType = yield call((): any => getOverviewIntervalPreviousOrdersFetchRequest({ from: prevStart, to: prevEnd }));
                yield put(getOverviewIntervalDataFetchSuccess({ ordersDataPrevious }));
            }),
            call(function* () {
                const receivingsDataActual: OverviewIntervalsResType = yield call((): any => getOverviewIntervalActualReceivingsFetchRequest({ from: start, to: end }));
                yield put(getOverviewIntervalDataFetchSuccess({ receivingsDataActual }));
            }),
            call(function* () {
                const receivingsDataPrevious: OverviewIntervalsResType = yield call((): any => getOverviewIntervalPreviousReceivingsFetchRequest({ from: prevStart, to: prevEnd }));
                yield put(getOverviewIntervalDataFetchSuccess({ receivingsDataPrevious }));
            }),
            call(function* () {
                const returnsDataActual: OverviewIntervalsResType = yield call((): any => getOverviewIntervalActualReturnsFetchRequest({ from: start, to: end }));
                yield put(getOverviewIntervalDataFetchSuccess({ returnsDataActual }));
            }),
            call(function* () {
                const returnsDataPrevious: OverviewIntervalsResType = yield call((): any => getOverviewIntervalPreviousReturnsFetchRequest({ from: prevStart, to: prevEnd }));
                yield put(getOverviewIntervalDataFetchSuccess({ returnsDataPrevious }));
            }),
            call(function* () {
                const claimsDataActual: OverviewIntervalsResType = yield call((): any => getOverviewIntervalActualClaimsFetchRequest({ from: start, to: end }));
                yield put(getOverviewIntervalDataFetchSuccess({ claimsDataActual }));
            }),
            call(function* () {
                const claimsDataPrevious: OverviewIntervalsResType = yield call((): any => getOverviewIntervalPreviousClaimsFetchRequest({ from: prevStart, to: prevEnd }));
                yield put(getOverviewIntervalDataFetchSuccess({ claimsDataPrevious }));
            }),
        ]);
    } catch (error) {
        yield put(getOverviewIntervalDataFetchFailure({ error }));
    }
}

export function* getOverviewIntervalDataFetchWatch() {
    yield takeEvery('overviewInterval/getOverviewIntervalDataFetch', getOverviewIntervalDataFetch);
}
function* getOverviewIntervalTypeDataFetch(action: { type: string; payload: { time: TimeRangesType; type: string } }) {
    const { start, end, groupBy } = action.payload.time;
    try {
        let fce: null | ((data: intervalParams) => Promise<any>) = null;
        switch (action.payload.type) {
            case 'orders':
                fce = getOverviewIntervalOrdersFetchRequest;
                break;
            case 'receivings':
                fce = getOverviewIntervalReceivingsFetchRequest;
                break;
            case 'returns':
                fce = getOverviewIntervalReturnsFetchRequest;
                break;
            case 'claims':
                fce = getOverviewIntervalClaimsFetchRequest;
                break;
        }

        let data: OverviewIntervalsResType | null = fce
            ? // @ts-ignore
              yield call((): any => fce({ from: start, to: end, groupBy: groupBy }))
            : null;

        yield put(
            getOverviewIntervalTypeDataFetchSuccess({
                type: action.payload.type,
                data,
            })
        );
    } catch (error) {
        yield put(getOverviewIntervalTypeDataFetchFailure({ error }));
    }
}

export function* getOverviewIntervalTypeDataFetchWatch() {
    yield takeEvery('overviewInterval/getOverviewIntervalTypeDataFetch', getOverviewIntervalTypeDataFetch);
}

const getOverviewIntervalOrdersInStatusesFetchRequest = async () => {
    const res = await api('get', `api/secure/statistics/orders-in-statuses`);
    return res.data;
};

function* getOverviewIntervalOrdersInStatusesFetch() {
    try {
        let response: OverviewIntervalsResType = yield call((): any =>
            getOverviewIntervalOrdersInStatusesFetchRequest()
        );

        yield put(getOverviewIntervalOrdersInStatusesFetchSuccess(response));
    } catch (error) {
        yield put(getOverviewIntervalOrdersInStatusesFetchFailure({ error }));
    }
}

export function* getOverviewIntervalOrdersInStatusesFetchWatch() {
    yield takeEvery(
        'overviewInterval/getOverviewIntervalOrdersInStatusesFetch',
        getOverviewIntervalOrdersInStatusesFetch
    );
}

const getOverviewIntervalOrdersDeliveredFetchRequest = async (from: string) => {
    const res = await api('get', `api/secure/statistics/orders-delivered-interval?from=${from}`);
    return res.data;
};

function* getOverviewIntervalOrdersDeliveredFetch(action: { type: string; payload: string }) {
    try {
        let response: OverviewIntervalsResType = yield call((): any =>
            getOverviewIntervalOrdersDeliveredFetchRequest(action.payload)
        );

        yield put(getOverviewIntervalOrdersDeliveredFetchSuccess(response));
    } catch (error) {
        yield put(getOverviewIntervalOrdersDeliveredFetchFailure({ error }));
    }
}

export function* getOverviewIntervalOrdersDeliveredFetchWatch() {
    yield takeEvery(
        'overviewInterval/getOverviewIntervalOrdersDeliveredFetch',
        getOverviewIntervalOrdersDeliveredFetch
    );
}
